<template>
  <div class="card mb-25 border-0 radius-7 bg-white expected-earnings-box">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <span
        class="d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis"
      >
        DATA
      </span>
      <div>
        
        <h4 class="fw-black mb-12 lh-1">{{ getMetricsToday.formatted_date }}</h4>
        
        <ul class="list ps-0 mb-0 list-unstyled mt-15">
          <li class="text-muted position-relative fw-medium">
            Dia da semana: <span class="text-black fw-bold">{{ getMetricsToday.day_of_week_name }}</span>
          </li>
          <li class="text-muted position-relative fw-medium">
            Semana do ano: <span class="text-black fw-bold">{{ getMetricsToday.week_of_year }}</span>
          </li>
          <li class="text-muted position-relative fw-medium">
            Dia do ano: <span class="text-black fw-bold">{{ getMetricsToday.day_of_year }}</span>
          </li>
          <li class="text-muted position-relative fw-medium">
            Trimestre: <span class="text-black fw-bold">{{ getMetricsToday.quarter }}</span>
          </li>
          <li class="text-muted position-relative fw-medium">
            Semestre: <span class="text-black fw-bold">{{ getMetricsToday.semester }}</span>
          </li>
        </ul>

        <span class="mt-4 fw-bold text-success text-badge d-inline-block">
          {{ getMetricsToday.compared_to_yesterday }}%
        </span>
        
        <div id="expectedEraningsChart" class="chart">
          <apexchart
            type="donut"
            height="150"
            :options="expectedEraningsChart"
            :series="[getMetricsToday.total_success, getMetricsToday.total_error]"
          ></apexchart>
        </div>

      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from 'vuex';

export default defineComponent({
  name: "ExpectedEarnings",
  data: function () {
    return {
      expectedEraningsChart: {
        chart: {
          height: 150,
          type: "donut",
        },
        dataLabels: {
          enabled: false,
        },
        labels: ["UPLOADS COM SUCESSO", "UPLOADS COM ERRO"],
        colors: ["#159269", "#C33F52"],
        legend: {
          show: false,
          fontWeight: 500,
          fontSize: "14px",
          fontFamily: "Red Hat Display, sans-serif",
          labels: {
            colors: "#607089",
          },
          markers: {
            offsetX: -2,
            offsetY: 1,
          },
        },
        stroke: {
          width: 0,
        },
        tooltip: {
          enabled: true,
          style: {
            fontSize: "14px",
            fontFamily: "Red Hat Display, sans-serif",
          },
        },
      },
    };
  },
  computed:{
    ...mapGetters([
      'getMetricsToday'
    ])
  },
});
</script>
